export const GOOGLE = 23087;
export const GOOGLE_MOBILE = 23088;

export const SEARCH_ENGINES = {
  [GOOGLE]: 'Google',
  [GOOGLE_MOBILE]: 'Google Mobile',
};
